import type { NavigationFilterDefinition } from '@repo/ui/helpers/navigation-filter-definitions';

export const LEGACY_FILTER_DEFINITIONS: NavigationFilterDefinition[] = [
  {
    badgeLabel: 'Represented',
    group: 'profile',
    key: 'isRepresented',
    kind: 'toggle',
    label: 'AGENCY REPRESENTATION',
  },
  {
    featuredValues: ['American', 'British', 'French', 'Italian'],
    group: 'profile',
    key: 'nationalities',
    kind: 'multiSelect',
    label: 'NATIONALITY',
    unit: 'nationality',
  },
  {
    featuredValues: [
      'London, England',
      'New York, New York',
      'Paris',
      'Milano, Milan',
    ],
    group: 'profile',
    key: 'cities',
    kind: 'multiSelect',
    label: 'CURRENT CITY',
    unit: 'city',
  },
  {
    group: 'profile',
    key: 'ages',
    kind: 'multiSelect',
    label: 'AGE',
    unit: 'age',
  },
  {
    badgeLabel: 'Height',
    group: 'attributes',
    key: 'heights',
    kind: 'range',
    label: 'HEIGHT',
    rangeUnit: 'cm',
    sliderTitle: 'height',
  },
  {
    badgeLabel: 'Chest',
    group: 'attributes',
    key: 'chests',
    kind: 'range',
    label: 'BUST/CHEST',
    rangeUnit: 'cm',
    sliderTitle: 'bust/chest',
  },
  {
    badgeLabel: 'Waist',
    group: 'attributes',
    key: 'waists',
    kind: 'range',
    label: 'WAIST',
    rangeUnit: 'cm',
    sliderTitle: 'waist',
  },
  {
    badgeLabel: 'Hips',
    group: 'attributes',
    key: 'hips',
    kind: 'range',
    label: 'HIPS',
    rangeUnit: 'cm',
    sliderTitle: 'hips',
  },
  {
    group: 'attributes',
    key: 'eyeColors',
    kind: 'multiSelect',
    label: 'EYE COLOR',
    unit: 'eye color',
  },
];
